import { createClient } from '@supabase/supabase-js';

const supabaseUrl = 'https://mtoqrxvqffjfbhnuhrpz.supabase.co'; // from step 3
const supabaseKey = 'sb_publishable_O9ip0meTfOJb0E0vCBdcVQ_Zc7rk8tm';                    // from step 3

export const supabase = createClient(supabaseUrl, supabaseKey);